import { AsYouType, parsePhoneNumber } from 'libphonenumber-js';
import * as logger from '../logger';

// e.g '(213) 373-4253'
export function maybeFormatNumberToNational(
  phoneNumber: string,
): string | null {
  try {
    const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'US');
    if (!parsedPhoneNumber.isPossible()) return null;
    return parsedPhoneNumber.formatNational();
  } catch (e) {
    logger.error(
      e,
      `maybeFormatNumberToNational: unable to parse phone number`,
    );
    return null;
  }
}

// e.g 'tel:+12133734253'
export function maybeGetPhoneUri(phoneNumber: string): string | null {
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber, 'US');
  if (!parsedPhoneNumber.isPossible()) return null;
  return parsedPhoneNumber.getURI();
}

export function normalize(phoneNumber: string): string {
  try {
    const parsed = parsePhoneNumber(phoneNumber, 'US');
    return parsed.formatNational().replace(/\D/g, '');
  } catch {
    return phoneNumber;
  }
}

export function prettify(phoneNumber: string): string {
  const normalized = normalize(phoneNumber);
  return new AsYouType('US').input(normalized);
}

export function isNumberValid(phoneNumber: string): boolean {
  if (!phoneNumber) return true;

  if (normalize(phoneNumber).length !== 10) return false;

  try {
    const phone = parsePhoneNumber(phoneNumber, 'US');
    return phone && phone.isValid();
  } catch (e) {
    return false;
  }
}

// formats phone number if more than 4 digits
export const formatPhone = (phoneNumber: string | undefined = ''): string => {
  if (normalize(phoneNumber).length > 4) {
    return new AsYouType('US').input(phoneNumber);
  }
  return phoneNumber;
};
